
export function distinctBy<V, K>(items: ReadonlyArray<V>, keySelector: (item: V) => K): V[] {
  if (!items)
    return [...items];

  let keys = new Set<K>();

  let results: V[] = [];

  for (let item of items) {
    let key = keySelector(item);
    if (keys.has(key))
      continue;

    keys.add(key);

    results.push(item);
  }

  return results;
}

